import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { Palette } from '@/themes/themeOverrides/Palette';
import { useTranslate } from 'react-admin';

const StyledDeviceIssueErrorDetailsModal = styled('div')(() => ({
    backgroundColor: Palette.white,
    padding: '12px 24px 24px',
    width: '369px',
    borderRadius: '16px',
    boxShadow: Palette.boxShadow.elevation16,
    fontSize: '11px',
    fontFamily: 'Inter, Arial, sans-serif !important',
    boxSizing: 'border-box',
    lineHeight: '16px',
    '& .device-sample-list-item': {
        display: 'flex',
        padding: '12px 0',
        borderBottom: `2px solid ${Palette.gray.gray100}`,
        '&:last-of-type': {
            borderBottom: 'none',
        },
        '& .device-sample-list-item-label': {
            width: '100px',
            flexShrink: 0,
        },
        '& .device-sample-list-item-value': {
            flex: 1,
            fontWeight: 600,
            wordBreak: 'break-word',
            '&.device-sample-list-item-details': {
                maxHeight: '200px',
                overflow: 'auto',
                paddingRight: '10px',
            },
        },
    },
    '& .title': {
        padding: '12px 0',
        borderBottom: `2px solid ${Palette.gray.gray100}`,
        fontWeight: 700,
    },
}));

const DeviceIssueErrorDetailsModal = ({ record }) => {
    const translate = useTranslate();
    const error = record?.error;
    if (!error) return null;

    return (
        <StyledDeviceIssueErrorDetailsModal>
            <Box className='title'>{translate('resources.deviceError.modal.title')}</Box>
            <Box className='device-sample-list-item'>
                <Box className='device-sample-list-item-label'>{translate('common.details')}</Box>
                <Box className='device-sample-list-item-value device-sample-list-item-details'>{error.details}</Box>
            </Box>
            <Box className='device-sample-list-item'>
                <Box className='device-sample-list-item-label'>{translate('resources.deviceError.labels.error')}</Box>
                <Box className='device-sample-list-item-value'>{error.name}</Box>
            </Box>
            <Box className='device-sample-list-item'>
                <Box className='device-sample-list-item-label'>{translate('resources.deviceError.labels.errorLevel')}</Box>
                <Box className='device-sample-list-item-value'>{error.level}</Box>
            </Box>
            <Box className='device-sample-list-item'>
                <Box className='device-sample-list-item-label'>{translate('resources.deviceError.labels.solutionTip')}</Box>
                <Box className='device-sample-list-item-value'>{error.solutionTip}</Box>
            </Box>
        </StyledDeviceIssueErrorDetailsModal>
    );
};

DeviceIssueErrorDetailsModal.propTypes = {
    record: PropTypes.shape({
        error: PropTypes.shape({
            code: PropTypes.number,
            name: PropTypes.string,
            level: PropTypes.number,
            title: PropTypes.string,
            solutionTip: PropTypes.string,
            time: PropTypes.string,
            details: PropTypes.string,
        }),
    }),
};

export default DeviceIssueErrorDetailsModal;
